import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ModalModule as NgxModalModule } from 'ngx-bootstrap/modal';
import { ModalService } from './modal.service';
import { ConfirmModalComponent } from './confirm-modal/confirm-modal.component';
import { NotificationDetailsComponent } from './notification-details-modal/notification-details.component';

@NgModule({
  declarations: [ConfirmModalComponent, NotificationDetailsComponent],
  imports: [CommonModule, TranslateModule, NgxModalModule.forRoot()]
})
export class ModalModule {
  public static forRoot(): ModuleWithProviders<ModalModule> {
    return {
      ngModule: ModalModule,
      providers: [ModalService]
    };
  }
}
